import { Croissant, Flame, Wheat } from 'lucide-react';
import { useTheme } from '@/theme/ThemeProvider';

/** Tasarıma göre marka işareti (Dolphin Fırın) */
export function BrandIcon({ size = 18 }: { size?: number }) {
  const { design } = useTheme();
  switch (design.id) {
    case 'obsidian': return <Croissant size={size} strokeWidth={2.4} className="text-black" />;
    case 'ledger': return <span className="brand-letter font-bold" style={{ fontSize: size * 0.85 }}>F</span>;
    case 'tasfirin': return <Flame size={size} strokeWidth={2.4} className="text-white" />;
    case 'maya': return <Wheat size={size} strokeWidth={2.2} className="text-[#fff4e2]" />;
    default: return <Croissant size={size} className="text-white" />;
  }
}
